import React, { useEffect, useState, useRef } from 'react'
import { debounce } from 'throttle-debounce'
import { trackPromise } from 'react-promise-tracker'
import { Link } from 'react-router-dom'

import { GetClients, GetClientCounts } from 'store/ClientsApiClient'

import IpsaSidebar from '../../../../layouts/IpsaSidebar'
import { MainContent } from '../../../../layouts/components/Structure'

import ListSidebar from './components/ListSidebar'
import ClientDisplay from './components/ClientDisplay'
import { GetRecentClients } from '../../../../store/ClientsApiClient'
import { ClientStatuses } from '../../../../variables/constants'

import LoadingWrapper from 'components/LoadingWrapper'

const Clients = () => {
    const PromiseArea = 'client-list'
    const RecentsPromiseArea = 'client-index-sidebar'

    const [showClients, setShowClients] = useState(false)
    const [clients, setClients] = useState([])
    const [recentClients, setRecentClients] = useState([])
    const [error, setError] = useState(null)

    const [refreshListCount, setRefreshListCount] = useState(0)

    const realSearch = useRef(
        debounce(250, (value) => {
            setSearchString(value)
        })
    ).current

    const [typingSearchString, setTypingSearchString] = useState('')
    const [searchString, setSearchString] = useState('')
    const [dropdownFilter, setDropdownFilter] = useState('allClients')
    const [clientCounts, setClientCounts] = useState({})

    const inputChanged = (value) => {
        setTypingSearchString(value)
        realSearch(value)
    }

    useEffect(() => {
        const UpdateAllClients = () => {
            trackPromise(
                GetClients(searchString, dropdownFilter)
                    .then((resp) => {
                        const { data } = resp
                        setClients(data)
                        setError(null)
                    })
                    .catch((err) => {
                        setClients([])
                        setError(err)
                    }),
                PromiseArea
            )
        }

        const UpdateClientCounts = () => {
            GetClientCounts()
                .then((resp) => {
                    const { data } = resp
                    setClientCounts(data)
                })
                .catch((err) => {
                    setClientCounts({})
                })
        }

        UpdateClientCounts()
        UpdateAllClients()
    }, [searchString, dropdownFilter, refreshListCount])

    useEffect(() => {
        const UpdateRecentClients = () => {
            trackPromise(
                GetRecentClients().then((resp) => {
                    const { data } = resp
                    setRecentClients(data)
                }),
                RecentsPromiseArea
            )
        }

        UpdateRecentClients()
    }, [refreshListCount])

    const RefreshList = () => {
        setRefreshListCount(refreshListCount + 1)
    }

    const ClientDropdownOption = (value, label, key) => {
        let count = clientCounts[key] || 0
        if (key === 'all') {
            const keys = Object.keys(clientCounts)
            count = keys.reduce((total, current) => clientCounts[current] + total, 0)
        }
        return (
            <option key={key} value={value}>
                {label} ({count})
            </option>
        )
    }

    return (
        <>
            <IpsaSidebar>
                <ListSidebar
                    recentClients={recentClients}
                    promiseArea={RecentsPromiseArea}
                    refreshFunction={RefreshList}
                    showClients={showClients}
                />
            </IpsaSidebar>
            <MainContent>
                <div className="col-section col-no-margin">
                    <div className="col-xs-6">
                        <form id="client-select">
                            <select
                                onChange={(event) => {
                                    const {
                                        target: { value },
                                    } = event
                                    setDropdownFilter(value)
                                }}
                            >
                                {ClientStatuses.map(({ value, label, key }) => {
                                    return ClientDropdownOption(value, label, key)
                                })}
                            </select>
                        </form>
                    </div>
                    <div className="col-xs-6">
                        <form
                            id="client-search"
                            onSubmit={(e) => {
                                e.preventDefault()
                            }}
                        >
                            <input
                                value={typingSearchString}
                                type="search"
                                onChange={(event) => {
                                    const {
                                        target: { value },
                                    } = event
                                    inputChanged(value)
                                }}
                                placeholder="Search First or Last Name"
                            />
                        </form>
                    </div>
                </div>
                <ul id="client-list-main" className="client-list">
                    <LoadingWrapper area={PromiseArea}>
                        {error && <li>There was a problem retreiving your clients</li>}
                        {!error && clients.length === 0 && (
                            <li>
                                <p>
                                    Create your first client
                                    <Link to="/clients/new" className="btn arrow-btn btn-right">
                                        ADD NEW CLIENT
                                    </Link>
                                </p>
                            </li>
                        )}
                        {clients && clients.length > 0 && (
                            <li>
                                <button
                                    type="button"
                                    className="btn btn-left"
                                    onClick={(event) => {
                                        setShowClients(!showClients)
                                    }}
                                >
                                    {showClients ? 'HIDE CLIENTS' : 'SHOW CLIENTS'}
                                </button>
                                <Link to="/clients/new" className="btn arrow-btn btn-right">
                                    ADD NEW CLIENT
                                </Link>
                            </li>
                        )}
                        {showClients &&
                            clients.map((client) => {
                                const { id, firstName, lastName, availableStatuses, status } =
                                    client
                                return (
                                    <ClientDisplay
                                        key={client.id}
                                        id={id}
                                        firstName={firstName}
                                        lastName={lastName}
                                        status={status}
                                        nextStatuses={availableStatuses}
                                        refreshList={RefreshList}
                                    />
                                )
                            })}
                    </LoadingWrapper>
                </ul>
                <div id="modal-portal"></div>
            </MainContent>
        </>
    )
}

export default Clients
